/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
module.exports = {
  resizeTable({tableId, gridApi, headerHeight}) {
    gridApi.resetRowHeights();
    let height = headerHeight + 10;
    gridApi.forEachNode(rowNode => height += rowNode.rowHeight);

    $(`#${tableId}`).css('height', height);
    return gridApi.sizeColumnsToFit();
  },

  markdownRowHeight({$container, text}) {
    const textHeight     = this._rowHeightFromText(text);
    const markdownHeight = this._markdownRowHeight($container);
    if (markdownHeight < 50) { return textHeight; } else { return markdownHeight; }
  },

  _rowHeightFromText(text) {
    if (!text) { return 60; }
    const adjustment = (text.length < 100 ? 2 : 1)
    const lineHeight = 28 * (Math.floor((text.length) / 70) + adjustment);
    if (lineHeight === 1) { return 1.2; } else { return lineHeight; }
  },

  _markdownRowHeight($container) {
    const $cell = $container.parents('.ag-cell');
    if (!$cell.length) { return 0; }

    const cellPadding     = parseInt($cell.css('padding'), 10) * 2;
    const cellBorderWidth = parseInt($cell.css('border-width'), 10) * 2;
    return $container.outerHeight(true) + cellPadding + cellBorderWidth;
  }
};
